import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as ChargingType } from '../../../assets/icons/charging-type.svg';
import { ReactComponent as CheckBoxActive } from '../../../assets/icons/check-box-active-icon.svg';
import { ReactComponent as CheckBox } from '../../../assets/icons/check-box-icon.svg';
import { ReactComponent as Clock } from '../../../assets/icons/clock-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-icon.svg';
import { ReactComponent as Search } from '../../../assets/icons/search-icon.svg';
import { ReactComponent as DefaultStationImage } from '../../../assets/icons/station-icon-view.svg';
import stationImage from '../../../assets/images/profile.jpg';
import { currentBranding } from '../../../config/branding';
import { GuestChargingDetails } from '../../../interface/guest-charging.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchGuestCharging } from '../../../redux/slice/GuestChargingSlice';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomDateRanges from '../../../shared-components/custom-date-range/CustomDateRanges';
// import CustomDateRange from '../../../shared-components/custom-date-range/CustomDateRange';
import CustomMultiDatePicker from '../../../shared-components/custom-date-range/CustomMultiDatePicker';
import CustomFileInput from '../../../shared-components/custom-file-input/CustomFileInput';
import CustomHoursLimit from '../../../shared-components/custom-hours-limit/CustomHoursLimit';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import CustomPhoneNumber from '../../../shared-components/custom-phone-number-input/CustomPhoneNumberInput';
import CustomMultiTimeSession from '../../../shared-components/custom-time-input/CustomMultiTimeSession';
import FormCancelWarning from '../../../shared-components/form-cancel-warning/FormCancelWarning';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import PageTitle from '../../../shared-components/page-title/PageTitle';
import RadioButton from '../../../shared-components/radio-button/RadioButton';
import SelectFiled from '../../../shared-components/select-field/SelectField';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotificaion';
import ConvertTimeToDate from '../../../shared-functions/ConvertDateToTime';
import ConvertToUTC from '../../../shared-functions/ConvertToUTC';
import ConvertUTCtoHHMM from '../../../shared-functions/ConvertUTCtoHHMM';
import { FormatUtcString } from '../../../shared-functions/FormatUtcString';
import {
  dateValidation,
  emailValidation,
  phoneNumberValidation,
  stringValidation,
} from '../../../shared-functions/Validation';
import deviceApi from '../../../utils/api/device';
import guestChargingApi from '../../../utils/api/guest-charging';
import stationApi from '../../../utils/api/station';

interface ModalBoxDetail {
  title: string | null;
  content: JSX.Element | null;
  notificationModal: boolean;
}

/**
 * Add new station component
 */
function AddGuestCharging() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { page, limit } = useAppSelector((state) => state.guestCharging);
  const [guestDetails, setGuestDetails] = useState<GuestChargingDetails>({
    name: '',
    type: 'phone',
    email: '',
    phoneNumber: '',
    userType: 'single',
    countryCode: currentBranding === 'energic' ? '966' : '1',
    profile: '',
    time: [],
    hour: '',
    minutes: '',
    fromDate: '',
    toDate: '',
    selectedDates: [],
    stationList: [],
    deviceList: [],
    bulkImport: [],
    rfidNo: '',
  });

  const [multiGuestUser, setMultiGuestUser] = useState<
    { name: string; phoneNumber: string; countryCode: string }[]
  >([]);

  const [multiGuest, setMultiGuest] = useState<{
    name: string;
    phoneNumber: string;
    countryCode: string;
  }>({
    name: '',
    phoneNumber: '',
    countryCode: currentBranding === 'energic' ? '966' : '1',
  });

  const [search, setSearch] = useState<string | number>('');
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    content: null,
    notificationModal: false,
  });
  const [formStatus, setFormStatus] = useState({
    showFormErrors: false,
    buttonLoader: false,
  });
  const [station, setStationList] = useState<any[]>([]);
  const [devices, setDevicesList] = useState<any[]>([]);

  const connectorTypes = [
    {
      label: 'Single User',
      value: 'single',
    },
    {
      label: 'Multi User',
      value: 'multi',
    },
  ];
  const profileList = [
    {
      label: 'Profile 1',
      value: 'profile1',
    },
    {
      label: 'Profile 2',
      value: 'profile2',
    },
  ];

  /**
   * Get the all station list function
   */
  const fetchAllStationsList = () => {
    stationApi
      .fetchAllStationDetails()
      .then((response) => {
        setStationList(response.data);
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Get the device details use station id function
   */
  const fetchAllStationList = (stationId: string) => {
    deviceApi
      .fetchAllDeviceDetailsList(stationId)
      .then((response) => {
        setDevicesList(response.data);
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Handle input value change
   * @param name
   * @param changeValue
   */
  const handleStationDetailChange = (
    name: string,
    changeValue: string | number | string[] | File[],
  ) => {
    if (guestDetails.type === 'phone') {
      setGuestDetails({
        ...guestDetails,
        email: '',
        [name]: changeValue,
      });
    } else {
      setGuestDetails({
        ...guestDetails,
        phoneNumber: '',
        [name]: changeValue,
      });
    }
  };
  /**
   * Handle input value change
   * @param name
   * @param changeValue
   */
  const handleGuestDetailsChange = (name: string, changeValue: string | number) => {
    setMultiGuest({
      ...multiGuest,
      [name]: changeValue,
    });
  };
  /**
   * Handle input value change
   * @param name
   * @param changeValue
   */
  const addStations = (name: string, changeValue: string) => {
    let output = [];
    if (guestDetails.stationList.includes(changeValue)) {
      output = guestDetails.stationList.filter((stationId) => stationId !== changeValue);
    } else {
      output = [...guestDetails.stationList, changeValue];
    }
    setGuestDetails({
      ...guestDetails,
      [name]: output,
    });
  };
  /**
   * Handle input value change
   * @param name
   * @param changeValue
   */
  const addDevices = (name: string, changeValue: string) => {
    let output = [];
    if (guestDetails.deviceList.includes(changeValue)) {
      output = guestDetails.deviceList.filter((stationId) => stationId !== changeValue);
    } else {
      output = [...guestDetails.deviceList, changeValue];
    }
    setGuestDetails({
      ...guestDetails,
      [name]: output,
    });
  };
  /**
   * Navigate back
   */
  const handleNavigateBack = () => {
    setGuestDetails({
      name: '',
      type: 'phone',
      email: '',
      phoneNumber: '',
      userType: '',
      countryCode: '',
      profile: '',
      time: [],
      hour: '0',
      minutes: '0',
      fromDate: '',
      toDate: '',
      selectedDates: [],
      stationList: [],
      deviceList: [],
      bulkImport: [],
      rfidNo: '',
    });
    setModalBoxStatus('close');

    navigate('../');
  };

  /**
   * Show warning when navigate back
   */
  const handleClickCancel = () => {
    setModalBoxDetail({
      title: '',
      content: (
        <FormCancelWarning
          title="Are you sure want to Cancel?"
          description="Any unsaved changes will be loss"
          cancelButtonLabel="Cancel"
          cancelButtonOnClick={() => setModalBoxStatus('close')}
          submitButtonLabel="OK"
          submitButtonOnClick={handleNavigateBack}
        />
      ),
      notificationModal: true,
    });
    setModalBoxStatus('open');
  };

  /**
   * add the multi guest user
   */
  const addMultiGuestUser = () => {
    setMultiGuestUser([...multiGuestUser, multiGuest]);
    setMultiGuest({
      name: '',
      phoneNumber: '',
      countryCode: currentBranding === 'energic' ? '966' : '1',
    });
  };
  /**
   * Delete the multi guest user
   */
  const deleteGuestUser = (index: number) => {
    setMultiGuestUser(multiGuestUser.filter((_, index_) => index_ !== index));
  };

  /**
   * Add station API call
   */
  const handleSubmitStationDetails = () => {
    console.log(guestDetails);
    setFormStatus({
      showFormErrors: true,
      buttonLoader: false,
    });
    if (
      stringValidation(1, 100, guestDetails.name) &&
      ((phoneNumberValidation(guestDetails.phoneNumber) && guestDetails.countryCode) ||
        emailValidation(guestDetails.email)) &&
      dateValidation(guestDetails.fromDate) &&
      dateValidation(guestDetails.toDate) &&
      guestDetails.fromDate < guestDetails.toDate
    ) {
      setFormStatus({
        showFormErrors: true,
        buttonLoader: true,
      });

      const timeSlots =
        guestDetails.time.length > 0
          ? guestDetails.time.map((value) => {
              const time = value.split(' - ');
              const startTime = ConvertTimeToDate(time[0]);
              let toTime: any = ConvertTimeToDate(time[1]);

              if (startTime > toTime) {
                const date = new Date(toTime);
                date.setUTCDate(date.getUTCDate() + 1);
                toTime = date.toISOString();
              }
              return {
                startTime,
                endTime: toTime,
              };
            })
          : [
              {
                startTime: ConvertTimeToDate('12:00 AM'),
                endTime: ConvertTimeToDate('11:59 PM'),
              },
            ];

      const request: any = {
        name: guestDetails.name,
        // countryCode: guestDetails.countryCode,
        // email: guestDetails.email,
        // phoneNumber: guestDetails.phoneNumber ?? guestDetails.phoneNumber,
        durationLimitInMins:
          (parseInt(guestDetails.hour, 10) * 60 || 0) + (parseInt(guestDetails.minutes, 10) || 0),
        chargingStationIds: guestDetails.stationList,
        chargingPoints: guestDetails.deviceList,
        // By default consider as start of the day
        onSelectiveDates: guestDetails.selectedDates.map((selectedDate) =>
          ConvertToUTC('00:00', selectedDate),
        ),
        fromDate: ConvertToUTC('00:00', guestDetails.fromDate),
        toDate: ConvertToUTC('00:00', guestDetails.toDate),
        timeSlots,
        rfidNo: guestDetails.rfidNo,
      };

      if (guestDetails.phoneNumber.length !== 0) {
        request.phoneNumber = guestDetails.phoneNumber;
        request.countryCode = guestDetails.countryCode;
      } else {
        request.email = guestDetails.email;
      }

      guestChargingApi
        .addGuestCharging(request)
        .then(() => {
          dispatch(fetchGuestCharging({ page, limit }));
          setModalBoxStatus('open');
          setFormStatus({
            showFormErrors: false,
            buttonLoader: false,
          });

          setModalBoxDetail({
            title: null,
            content: (
              <SuccessNotification
                title="Guest Charging Added Successfully "
                description="Your guest is saved successfully"
                notificationCloseTimer={3000}
                onNotificationClose={handleNavigateBack}
              />
            ),
            notificationModal: true,
          });
        })
        .catch((error) => {
          setFormStatus({
            showFormErrors: false,
            buttonLoader: false,
          });
          setModalBoxStatus('close');
          dispatch(
            setNotificationDetails({
              type: 'error',
              notificationDetails: {
                statusCode: error?.response?.data?.code || 200,
                message: error?.response?.data?.message || 'Something went wrong!',
              },
            }),
          );
        });
    }
  };

  useEffect(() => {
    fetchAllStationsList();
  }, []);

  return (
    <div className="add-Guest-wrap">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        notification={modalBoxDetail.notificationModal}
        header={!modalBoxDetail.notificationModal}
      />
      <div className="add-Guest-header">
        <PageTitle title="Add Guest" />
      </div>
      <div className="add-Guest-container">
        <div className="add-Guest-from-wrap">
          <div className="form-field">
            {false && (
              <SelectFiled
                inputLabel=""
                name="userType"
                placeholder="Select User Type"
                options={connectorTypes}
                selectedValue={guestDetails.userType}
                valueRequired
                onChangeValue={handleStationDetailChange}
              />
            )}
            {guestDetails.userType === 'multi' && (
              <SelectFiled
                inputLabel=""
                name="profile"
                placeholder="Select profile"
                options={profileList}
                selectedValue={guestDetails.profile}
                valueRequired
                onChangeValue={handleStationDetailChange}
              />
            )}
            {guestDetails.userType === 'multi' && (
              <CustomFileInput
                inputLabel=""
                acceptedFileType="application/pdf"
                placeholder="Chose file (Bulk Import)"
                name="bulkImport"
                selectedFiles={guestDetails.bulkImport}
                onChangeValue={handleStationDetailChange}
              />
            )}
          </div>
          <div className="add-Guest-from">
            {guestDetails.userType === 'multi' && (
              <div className="column-field">
                <CustomInput
                  inputLabel="Guest Name"
                  type="text"
                  placeholder="Enter the Name"
                  name="name"
                  value={multiGuest.name}
                  onChangeValue={handleGuestDetailsChange}
                />
                <CustomPhoneNumber
                  inputLabel="Phone Number"
                  placeholder="Enter the Phone number"
                  name="phoneNumber"
                  value={multiGuest.phoneNumber}
                  onChangeValue={handleGuestDetailsChange}
                  countryCode={multiGuest.countryCode}
                />
                <div className="form-buttons-wrap">
                  <MyButton label="Add" buttonType="submit" onClickFunc={addMultiGuestUser} />
                </div>
              </div>
            )}
            {guestDetails.userType === 'multi' && (
              <div className="column-field">
                <table className="table">
                  <tr className="header">
                    <td className="sno">S. No</td>
                    <td>Guest Name</td>
                    <td>Phone Number</td>
                    <td className="action">Action</td>
                  </tr>
                  {multiGuestUser.map((guestUser, index) => (
                    <tr>
                      <td className="sno">{index + 1}</td>
                      <td>{guestUser.name}</td>
                      <td>
                        +{guestUser.countryCode} {guestUser.phoneNumber}
                      </td>
                      <td className="action">
                        <div
                          className="icon"
                          onClick={() => deleteGuestUser(index)}
                          role="presentation">
                          <DeleteIcon />
                        </div>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            )}
            {guestDetails.userType !== 'multi' && (
              <CustomInput
                inputLabel="Guest Name"
                type="text"
                placeholder="Enter the Name"
                name="name"
                value={guestDetails.name}
                onChangeValue={handleStationDetailChange}
                valueRequired
                error={!stringValidation(1, 100, guestDetails.name) && formStatus.showFormErrors}
                errorMessage="Guest name is required"
              />
            )}
            {guestDetails.userType !== 'multi' && (
              <div className="input-toggle">
                <RadioButton
                  name="type"
                  value={guestDetails.type}
                  list={[
                    {
                      label: 'Phone Number',
                      value: 'phone',
                    },
                    {
                      label: 'Email',
                      value: 'email',
                    },
                  ]}
                  onChangeValue={handleStationDetailChange}
                />
                {guestDetails.type === 'phone' ? (
                  <CustomPhoneNumber
                    placeholder="Enter the Phone number"
                    name="phoneNumber"
                    value={guestDetails.phoneNumber}
                    onChangeValue={handleStationDetailChange}
                    countryCode={guestDetails.countryCode}
                    error={
                      !phoneNumberValidation(guestDetails.phoneNumber) && formStatus.showFormErrors
                    }
                    errorMessage="Invalid phone number"
                  />
                ) : (
                  <CustomInput
                    type="text"
                    placeholder="Enter the email"
                    name="email"
                    value={guestDetails.email}
                    onChangeValue={handleStationDetailChange}
                    error={!emailValidation(guestDetails.email) && formStatus.showFormErrors}
                    errorMessage="Invalid email id"
                  />
                )}
              </div>
            )}
            <CustomInput
              type="text"
              placeholder="Enter RFID number"
              name="rfidNo"
              inputLabel="RFID Number"
              value={guestDetails.rfidNo}
              onChangeValue={handleStationDetailChange}
            />
            <CustomDateRanges
              name1="fromDate"
              name2="toDate"
              inputLabel="Date"
              value1={guestDetails.fromDate}
              value2={guestDetails.toDate}
              onChangeValue={handleStationDetailChange}
              valueRequired
              error={
                !(
                  guestDetails.fromDate &&
                  guestDetails.toDate &&
                  dateValidation(guestDetails.fromDate) &&
                  dateValidation(guestDetails.toDate) &&
                  guestDetails.fromDate < guestDetails.toDate
                ) && formStatus.showFormErrors
              }
              errorMessage="Invalid date range"
            />
            <CustomMultiDatePicker
              inputLabel="Select Particular Date"
              placeholder=""
              name="selectedDates"
              value={guestDetails.selectedDates}
              onChangeValue={handleStationDetailChange}
              validFromDate={guestDetails.fromDate}
              validToDate={guestDetails.toDate}
            />
            <CustomMultiTimeSession
              inputLabel="Time"
              placeholder=""
              name="time"
              value={guestDetails.time}
              onChangeValue={handleStationDetailChange}
            />
            <CustomHoursLimit
              inputLabel="Hours Limit"
              hourValue={guestDetails.hour}
              minutesValue={guestDetails.minutes}
              onChangeValue={handleStationDetailChange}
              valueRequired
              error={!guestDetails.hour && !guestDetails.minutes && formStatus.showFormErrors}
              errorMessage="Hours limit is required"
            />
          </div>
          <div className="add-Guest-from">
            <div className="station-list">
              <div className="station-list-header">
                <CustomInput
                  svgIcon={<Search />}
                  inputLabel=""
                  type="text"
                  placeholder="Search Station"
                  name="search"
                  value={search}
                  onChangeValue={(name, value) => setSearch(value)}
                />
              </div>
              <div className="station-list-body">
                <div className="station-list-contents">
                  {station
                    .filter((stationDetails) =>
                      stationDetails.name.toLowerCase().includes(String(search).toLowerCase()),
                    )
                    .map((stationDetails) => (
                      <div
                        className="station-item"
                        onClick={() => fetchAllStationList(stationDetails._id)}
                        role="presentation">
                        <div
                          className="check-box"
                          onClick={() => addStations('stationList', stationDetails._id)}
                          role="presentation">
                          {guestDetails.stationList.includes(stationDetails._id) ? (
                            <CheckBoxActive />
                          ) : (
                            <CheckBox />
                          )}
                        </div>
                        <div className="station-image">
                          <img
                            src={stationDetails?.medias?.[0]?.signedUrl || stationImage}
                            alt="station-image"
                          />
                        </div>
                        <div className="station-details">
                          <div className="station-name">{stationDetails.name}</div>
                          <div className="station-time">
                            {stationDetails.isAvailable ? (
                              <div className="tag-success-label">Active</div>
                            ) : (
                              <div className="tag-danger-label">Inactive</div>
                            )}
                            <div className="time">
                              <Clock /> {FormatUtcString(ConvertUTCtoHHMM(stationDetails.opensAt))}{' '}
                              - {FormatUtcString(ConvertUTCtoHHMM(stationDetails.closesAt))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="device-list-card">
              <div className="card">
                <div className="card-contents">
                  <div className="device-list">
                    {devices.map((deviceDetails) => (
                      <div className="device-item">
                        <div
                          className="check-box"
                          onClick={() => addDevices('deviceList', deviceDetails.chargingPointSn)}
                          role="presentation">
                          {guestDetails.deviceList.includes(deviceDetails.chargingPointSn) ? (
                            <CheckBoxActive />
                          ) : (
                            <CheckBox />
                          )}
                        </div>
                        <div className="device-details">
                          <div className="device-details-contents-1">
                            <div className="device-icon">
                              <div className="icon">
                                <DefaultStationImage />
                              </div>
                            </div>
                            <div className="device-name">
                              <div className="device-title">
                                {deviceDetails.chargingPointName} - {deviceDetails.chargingPointSn}
                              </div>
                              <div className="device-title">{deviceDetails.connectorType}</div>
                            </div>
                            <div className="device-status">
                              {deviceDetails.isAvailable ? (
                                <div className="tag-success-label">Active</div>
                              ) : (
                                <div className="tag-danger-label">Inactive</div>
                              )}
                            </div>
                          </div>
                          <div className="device-details-contents-2">
                            <div className="connectors-list">
                              {deviceDetails.connectors.map((connector: any) => (
                                <div className="connector-item tag-default-label">
                                  <ChargingType /> Connector {connector.connectorId}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="add-guest-button-wrap">
          <div className="form-buttons-wrap">
            <MyButton label="Cancel" buttonType="back" onClickFunc={handleClickCancel} />
            <MyButton
              label="Submit"
              buttonType="submit"
              onClickFunc={handleSubmitStationDetails}
              loading={formStatus.buttonLoader}
              disableButton={formStatus.buttonLoader}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddGuestCharging;
